/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Box, Chip, CircularProgress, Link, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Accordion, AccordionDetails, AccordionSummary } from "../common/Accordion";
import theme from "../styles/theme";
import { Exercise } from "../types";
import Description from "./Description";
import { ExerciseName, MediaContainer, StyledImage, StyledVideo } from "./Exercise.sc";

interface ExerciseContentProps {
    exercise: Exercise;
}
const ExerciseContent: React.FunctionComponent<ExerciseContentProps> = ({ exercise }) => {
    const { t, i18n } = useTranslation();
    const [expanded, setExpanded] = React.useState(true);
    const [imageLoading, setImageLoading] = useState(true);

    useEffect(() => {
        setImageLoading(true);
    }, [exercise.image]);

    const handleChange = () => {
        setExpanded(!expanded);
    };

    const handleImageLoaded = () => {
        setImageLoading(false);
    };

    return (
        <Box sx={{ maxWidth: 700 }}>
            <Chip
                style={{
                    backgroundColor: theme.colors[exercise.category],
                    color: "white",
                    marginTop: 10,
                    marginBottom: 10,
                }}
                label={t(exercise.category)}
            />
            <ExerciseName variant="h4" gutterBottom>
                {i18n.language === "de" ? exercise.nameDe : exercise.nameEn}
            </ExerciseName>
            <MediaContainer>
                {imageLoading && (
                    <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                        <CircularProgress />
                    </div>
                )}
                {exercise.image.includes("mp4") ? (
                    <StyledVideo src={exercise.image} autoPlay controls onLoadStart={handleImageLoaded} loop playsInline />
                ) : (
                    <StyledImage src={exercise.image} key={exercise.image} onLoad={handleImageLoaded} />
                )}
            </MediaContainer>
            {exercise.equipmentDe && exercise.equipmentEn && (
                <Typography gutterBottom style={{ marginTop: 20 }}>
                    <b>{t("equipment")}:</b> {i18n.language === "de" ? exercise.equipmentDe : exercise.equipmentEn}
                </Typography>
            )}
            {exercise.recommendationDe && exercise.recommendationDe && (
                <Typography gutterBottom style={{ marginTop: 20 }}>
                    <b>{t("recommendation")}:</b> {i18n.language === "de" ? exercise.recommendationDe : exercise.recommendationEn}
                </Typography>
            )}
            <Accordion expanded={expanded} onChange={handleChange} style={{ marginTop: 20 }}>
                <AccordionSummary>
                    <Typography>{expanded ? t("hide_instruction") : t("show_instruction")}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Description description={i18n.language === "de" ? exercise.descriptionDe : exercise.descriptionEn} />
                </AccordionDetails>
            </Accordion>
            {exercise.source && (
                <Typography gutterBottom style={{ marginTop: 20 }}>
                    <Link color="primary" href={exercise.source} target="_blank">
                        <b>{t("source")}:</b>
                    </Link>
                </Typography>
            )}
        </Box>
    );
};

export default ExerciseContent;
